InternalQueryReference